<!--
	TEMPLATE
-->
<template>
<div class="editable-rooms">
	<div v-if="!isEditView">{{ label }}</div>

	<div v-if="isEditView" class="editable-rooms__select">
		<div @click="selectPrev()" id="prev"><i class="ico-right_arrow"></i></div>
		<div v-model="selected" id="label">{{ label }}</div>
		<div @click="selectNext()" id="next"><i class="ico-right_arrow"></i></div>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';

export default {
	props: {
		value: [String, Number],
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			ID: 0,
			TEXT: 1
		}
	},
	methods: {
		selectNext: function(){
			if(this.selected < this.options.items.length - 1){
				this.selected += 1;
			}
		},
		selectPrev: function(){
			if(this.selected > 0){
  				this.selected -= 1;
			}
		}
	},
	computed: {
		selected: vModelNested,
		label: function() {
			var that = this;
			var item = this.options.items.find(function(element) {
				return element[that.ID] === that.selected
			})
			return typeof item !== 'undefined' ? item[that.TEXT] : ''
		},
	}
}
</script>
